import React from 'react';
import styled from 'styled-components';
import BlogHeader from '../blog/components/blog-header';
import NavComponent from '../navbar';
import { useExternalMedia } from "../../hooks/useExternalMedia";

const Section = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background-color: transparent;
	background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

const BlogHero = ({ slug }) => {
	const {blogHero} = useExternalMedia()
	return (
		<Section
		
		style={{
			backgroundImage: `url(${blogHero})`
		}}
		
		>
			<section
				id="blog-hero"
				className="section hero-section">
				<NavComponent
				/>

        <BlogHeader
          slug={slug}
        />
			</section>

		</Section>
	)
}

export default BlogHero;